import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=e5e608ce&scoped=true"
import script from "./NotificationList.vue?vue&type=script&lang=js"
export * from "./NotificationList.vue?vue&type=script&lang=js"
import style0 from "./NotificationList.vue?vue&type=style&index=0&id=e5e608ce&prod&scoped=true&lang=css"
import style1 from "./NotificationList.vue?vue&type=style&index=1&id=e5e608ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e608ce",
  null
  
)

export default component.exports